<template>
  <div id="locationFinder" class="flyntComponent ">
    <loading :active.sync="loading" is-full-page></loading>

    <div class="content centerContentMaxWidth">
      <div id="map-controls">
        <div id="pac-card">
          <div>
            <div id="title">Find A Location</div>
          </div>
          <div id="pac-container">
            <label for="userAddress">

              <div id="autoLocater">
                <button id="blue-bttn" title="Your Location" @click="autoLocate">
                  <div id="content" style="background-position: 0px 0px;"></div>
                </button>
              </div>
              <input name="userAddress"
                     v-model="search"
                     id="userAddress"
                     placeholder="Enter Zip:"
                     autocomplete="off" @keyup.enter="newSearchForZip">
            </label>
            <button class="yellow-bttn" id="submitLocationSearch" @click="newSearchForZip">GO</button>
          </div>

          <div id="location-search-alert" v-show="displayResults && locations.length">
            {{ locations.length }} Locations found. <br/>
            <a id="clear" @click.prevent="clearResults">Clear Search</a>
          </div>
          <div v-show="showMultipleLocsCTA" id="showMultipleLocsCTA">
            <span>Are you a national business with locations across the country? If so, please click the button below.</span> <a :href="config.multiLocationsCTAURL" class="showMultipleLocsCTA">Get Started</a>
          </div>

        </div>

        <div id="panel" v-if="!loading">
          <Location v-for="location in locations" :key="location.id" :location="location"
                    v-show="displayResults"></Location>

        </div>

      </div>
      <div id="map" style="position: relative; overflow: hidden;"></div>
    </div>
  </div>

</template>

<script>

// import GoogleMapLoader from "./components/GoogleMapLoader";
import CustomModal                    from "./components/CustomModal";
import Location                       from "./components/Location";
// import { GoogleMap } from "@googlemaps/map-loader";
import VueScreenSize                  from "vue-screen-size";
import gmapsInit                      from "./components/gmaps";
import Loading                        from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { default as MarkerClusterer } from "@google/markerclusterer";

export default {
  name:       "App",
  components: { CustomModal, Location, Loading },
  mixins:     [VueScreenSize.VueScreenSizeMixin],
  data() {
    return {
      apiKey:          googlemap_deps.api,
      loading:         false,
      allLocations:    [],
      locations:       [],
      origin:          null,
      googleLocations: [],
      search:          null,
      clusterer:       null,
      clusterers:      [],
      googleMap:       null,
      isBoundable:     false,
      map:             null,
      displayResults:  true,
      markers:         [],
      bounds:          [],
      infoWindow:      null,
      url:             null,
      location:        null,
      location_marker: null,
      USCoords:        {
        // W: {lat: 40.434453, lng: -124.402267},
        // S: {lat: 25.160259, lng: -80.391039},
        // N: {lat: 49.378838, lng: -95.134691},
        // E: {lat: 44.789678, lng: -67.009693},
        NorthEast: {
          lat: 49.38,
          lng: -66.94,
        },
        SouthWest: {
          lat: 25.82,
          lng: -124.39,
        },
      },
      mapOptions:      {
        mapTypeId: "roadmap",
        center:    { lat: 39.8097343, lng: -98.5556199 },
        zoom:      5,
      },
      apiOptions:      {
        version:   "weekly",
        libraries: ["geometry"],
      },
    };
  },

  computed: {
    showMultipleLocsCTA(){
      return this.config.blog_id == 1 && this.config.multiLocationsCTA && this.config.multiLocationsCTAURL
    },
    modal() {
      return $( "#location-modal" );
    },
    country() {
      const letters = /(?=.*?[A-Za-z])/;

      return letters.test( this.search ) ? "CA" : "US";
    },
    markerIcon() {
      return googlemap_deps.domain + "/assets/blue-dot.png";
    },
    originMarkerIcon() {
      return googlemap_deps.domain + "/assets/user-pin.png";
    },
    isMobile() {
      let check = false;
      ( function( a ) {
        if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a ) ||
             /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                 a.substr( 0, 4 ) ) ) check = true;
      } )( navigator.userAgent || navigator.vendor || window.opera );
      return check;
    },
    config() {
      return googlemap_deps ? googlemap_deps : {
        "domain":            "",
        "blog_id":           0,
        "site_title":        "",
        "APIIntegration":    1,
        "googleMapAPI":      "",
        "iframe":            0,
        "radius":            50,
        "singleLocation":    true,
        "useRadius":         false,
        "limit":             3,
        "clusterers_folder": "",
      };
    },

  },

  watch: {
    // modal( newVal ) {
    // 	if ( !newVal ) {
    //     $("#location-modal").hide();
    // 	}else{
    //     $("#location-modal").show();
    //     $("body").on("click", "#closeBttn", function(){
    //       $("#location-modal").hide();
    //     })
    //   }
    //   this.reInitLocations();
    // },
    $vssWidth( newVal ) {
      this.setZoomDynamic();
    },
  },
  async created() {
    // if ( process.env.node_env === "development" ) {
    //   this.url = "https://1800waterdamage.com.synapseresults.com/wp-json/belfor/v1/zipcodes/";
    // } else {
    this.url = this.config.domain + "/wp-json/belfor/v1/zipcodes";
    if ( !( "geolocation" in navigator ) ) {
      // this.errorStr = "Geolocation is not available.";
      return;
    }
    this.location = await this.getCurrentLoc();

    // console.log( this.location.coords );
    // }
    /*
     * Set ID of the div where the map will be loaded,
     * and whether to append to that div.
     */
    // const mapLoaderOptions = {
    //   apiKey:     this.apiKey,
    //   divId:      "map",
    //   append:     false, // Appends to divId. Set to false to init in divId.
    //   mapOptions: this.mapOptions,
    //   apiOptions: this.apiOptions,
    // };
    // // Instantiate map loader
    // this.googleMap = new GoogleMap();
    //
    // // Load the map
    // this.googleMap.initMap( mapLoaderOptions )
    //     .then( googleMap => {
    //       this.map = googleMap;
    //
    //
    //     } );

    // this.googleMap = new google.maps.Map(document.getElementById("map"), this.mapOptions);

  },
  async mounted() {
    try {
      const google = await gmapsInit( this.config.googleMapAPI );
      const geocoder = new google.maps.Geocoder();
      this.googleMap = new google.maps.Map( document.getElementById( "map" ), this.mapOptions );

      // geocoder.geocode({ address: 'Austria' }, (results, status) => {
      //   if (status !== 'OK' || !results[0]) {
      //     throw new Error(status);
      //   }
      //
      //   this.googleMap.setCenter(results[0].geometry.location);
      //   this.googleMap.fitBounds(results[0].geometry.viewport);
      // });

      this.infoWindow = new google.maps.InfoWindow();
      // google.maps.event.addDomListener(this.map.getDiv(),'resize', function(evt){
      //   console.log('resizing');
      // });
      // 			google.maps.event.addListener(this.googleMap, 'bounds_changed', function(event) {
      // 											console.log('bounds  changese');
      // 				if (this.getZoom() > 15) {
      // 					// Change max/min zoom here
      // 					this.setZoom(15);
      // 					// this.initialZoom = false;
      // 				}
      // 				// google.maps.event.removeListener(zoomChangeBoundsListener);
      // 			});

      window.addEventListener( "resize", ( e ) => {
        // console.log('resizing');
        let width = document.body.clientWidth;
        let height = document.body.clientHeight;
        // console.log('width', width);
        this.resize();
      } );

      this.resize();
      this.initialLoads();

    } catch ( error ) {
      console.error( error );
    }
  },

  methods: {
    async searchByRadius() {
      let url = this.config.domain + "/wp-json/public/v1/locations/" + this.search;
      try {
        const results = await this.$http.get( url );
        const data = results.data.results;
        return this.allLocations.filter(
            loc => {
              loc.distance = +this.distance( loc, this.location );
              // return data.some( d => Object.keys( d ).some( prop => loc[ prop ] === d[ prop ] ) );
              return data.includes( loc.id );
            } ).sort( ( a, b ) => {
          if ( a.distance > b.distance ) return 1;
          if ( a.distance < b.distance ) return -1;
          return 0;
        } );
      } catch ( err ) {

      }
      return [];
    },
    searchByZips() {

    },

    async getCurrentLoc() {

      return new Promise( ( resolve, reject ) => {

        if ( !( "geolocation" in navigator ) ) {
          reject( new Error( "Geolocation is not available." ) );
        }

        navigator.geolocation.getCurrentPosition( pos => {
          resolve( pos );
        }, err => {
          reject( err );
        } );

      } );
    },
    resize( map ) {
      // this.map.setCenter( this.map.getCenter() );
      // this.map.fitBounds( path_bounds );
      // if ( !this.map.getCenter() ) {
      const map_center = new google.maps.LatLng( 39.8097343, -98.5556199 );
      this.googleMap.setCenter( map_center );
      // // }
      //
      var USbounds = new google.maps.LatLngBounds(
          new google.maps.LatLng( this.USCoords.SouthWest.lat, this.USCoords.SouthWest.lng ),
          new google.maps.LatLng( this.USCoords.NorthEast.lat, this.USCoords.NorthEast.lng ) );

      this.googleMap.fitBounds( USbounds );

    },
    setZoomDynamic() {
      // if ( this.$vssWidth <= 768 ) {
      //   var USbounds = new google.maps.LatLngBounds(
      //     new google.maps.LatLng( this.USCoords.SouthWest.lat, this.USCoords.SouthWest.lng ),
      //     new google.maps.LatLng( this.USCoords.NorthEast.lat, this.USCoords.NorthEast.lng ) );
      //   this.map.fitBounds( USbounds );
      //   this.map.setZoom( 3 );
      // } else if ( this.$vssWidth > 768 ) {
      //   var USbounds = new google.maps.LatLngBounds(
      //     new google.maps.LatLng( this.USCoords.SouthWest.lat, this.USCoords.SouthWest.lng ),
      //     new google.maps.LatLng( this.USCoords.NorthEast.lat, this.USCoords.NorthEast.lng ) );
      //   this.map.fitBounds( USbounds );
      //   this.map.setZoom( 5 );
      // }

    },
    fitBoundsLocations() {
      // console.log( "fitbounds" );
      this.bounds = new google.maps.LatLngBounds();
      for ( let i = 0; i < this.markers.length; i++ ) {
        let m = this.markers[ i ];
        this.bounds.extend( m.position );
      }

      this.googleMap.fitBounds( this.bounds );
      this.googleMap.panToBounds( this.bounds );

      // map.fitBounds(bounds);
      // var zoom = map.getZoom();
      // map.setZoom(zoom > 6 ? 6 : zoom);
      let zoom = this.googleMap.getZoom();
      // console.log( "zoom", zoom );
      // console.log( "vss", this.$vssWidth );
      if ( this.locations.length === 1 ) {
        this.googleMap.setZoom( 8 );
      } else {
        this.googleMap.setZoom( 6 );
      }
      // 			console.log('resizing');
      // this.resize(this.googleMap);
    },
    initialLoads() {
      this.loading = true;
      $.getJSON( this.url, results => {
        const locations = results.results;
        // console.log(locations)
        if ( locations.length ) {
          for ( let i = 0; i < locations.length; i++ ) {
            let loc = locations[ i ];
            if ( loc.zipcode && loc.zipcode.longitude && loc.zipcode.latitude ) {

              const newLoc = {
                id:              loc.id,
                blog_id:         loc.blog.blog_id,
                name:            loc.name,
                lat:             loc.zipcode.latitude,
                lng:             loc.zipcode.longitude,
                address:         loc.address,
                address2:        loc.address2,
                city:            loc.city,
                state:           loc.state,
                zip:             loc.zip,
                emergency_phone: loc.emergency_phone,
                local_phone:     loc.local_phone,
                email:           loc.email,
                link:            this.cleanDomain( loc.blog.domain ),
                polygon:         loc.zipcode.geometry,
                areas:           loc.support_zips,
                place:           loc.place,
                dots:            loc.dots,
                rsas:            loc.rsas,
                distance:        null,
                show_address:    loc.show_address,
              };
              this.locations.push( newLoc );
              this.allLocations.push( newLoc );
            }
          }
          this.sortByDistance();
          this.displayResults = false;
          this.mountLocations();
          // console.log( "locations", this.locations );
          if ( posted_zip ) {
            this.search = posted_zip;
            this.displayResults = true;
            this.newSearchForZip();
          }
        }
      } );
    },
    sortByDistance() {
      // if ( this.location ) {
      this.locations.sort( ( a, b ) => {
        if ( a.distance > b.distance ) return 1;
        if ( a.distance < b.distance ) return -1;
        return 0;
      } );
      // }
    },
    reInitLocations() {
      this.locations = Object.assign( this.locations, this.allLocations );
      this.displayResults = false;
      this.mountLocations();
    },
    cleanDomain( url ) {
      return url.search( "http" ) === -1 ? "https://" + url : url;
    },
    clearMarkers() {
      if ( this.location_marker ) {
        this.location_marker.setMap( null );
        this.location_marker = null;
      }
      this.markers.forEach( m => {
        m.setMap( null );
      } );
      this.markers = [];
      // this.clusterer.clearMarkers();
      this.locations = [];
      this.bounds = new google.maps.LatLngBounds();
    },
    handleClickOutside() {
      this.loading = false;
      this.hideModal();
    },
    deg2rad( deg ) {
      return deg * ( Math.PI / 180 );
    },
    distance( p1, origin ) {
      let loc = { lat: null, lng: null };
      if ( origin ) {
        loc.lat = this.location.geometry.location.lat;
        loc.lng = this.location.geometry.location.lng;
      } else {
        return;
      }

      if ( !p1 || !loc.lat ) return 0;
      let R = 3959; // Radius of the Earth in m
      let dLat = ( loc.lat - p1.place.geometry.location.lat ) * Math.PI / 180;
      let dLon = ( loc.lng - p1.place.geometry.location.lng ) * Math.PI / 180;
      let a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
              Math.cos( p1.place.geometry.location.lat * Math.PI / 180 ) * Math.cos( loc.lat * Math.PI / 180 ) *
              Math.sin( dLon / 2 ) * Math.sin( dLon / 2 );
      let c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) );
      let d = R * c;

      return d.toFixed( 2 );
    },

    distance3( p1, origin ) {
      let sin = Math.sin( ( origin.geometry.location.lat * Math.PI / 180 ) );
      let sin2 = Math.sin( ( p1.place.geometry.location.lat * Math.PI / 180 ) ) +
                 Math.cos( ( origin.geometry.location.lat * Math.PI / 180 ) );
      let cos = Math.cos( ( p1.place.geometry.location.lat * Math.PI / 180 ) ) *
                Math.cos( ( ( origin.geometry.location.lng - p1.place.geometry.location.lng ) * Math.PI / 180 ) );
      let acos = ( sin * sin2 * cos ) * 180 / Math.PI;

      return acos * 60 * 1.1515 * 1.609344;
    },
    distance2( p1, origin, unit = "M" ) {
      let loc = { lat: null, lng: null };
      if ( origin ) {
        loc.lat = this.location.geometry.location.lat;
        loc.lng = this.location.geometry.location.lng;
      } else {
        return;
      }

      if ( !p1 || !loc.lat ) return 0;

      var radlat1 = Math.PI * p1.place.geometry.location.lat / 180;
      var radlat2 = Math.PI * origin.geometry.location.lat / 180;
      var theta = p1.place.geometry.location.lng - origin.geometry.location.lng;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin( radlat1 ) * Math.sin( radlat2 ) + Math.cos( radlat1 ) * Math.cos( radlat2 ) *
                 Math.cos( radtheta );
      if ( dist > 1 ) {
        dist = 1;
      }
      dist = Math.acos( dist );
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if ( unit == "K" ) { dist = dist * 1.609344; }
      if ( unit == "N" ) { dist = dist * 0.8684; }
      return dist;
    },
    async getZipFromGoogle() {
      let url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + this.search + ", " + this.country +
                "&key=" + this.config.googleMapAPI;
      try {
        const response = await this.$http.get( url );
        return response.data;
      } catch ( err ) {

      }

    },

    async newSearchForZip() {
      this.clearMarkers();
      this.loading = true;
      const results = await this.getZipFromGoogle();
      // console.log( results );
      this.location = results.status === "OK" ? results.results[ 0 ] : null;

      if ( !this.location ) {
        this.triggerNotFoundModal();
        return;
      }

      // throw a modal if it wasn't a zipcode.
      if ( this.location.types[ 0 ] !== "postal_code" ) {
        console.log( "not found" );
        this.triggerNotFoundModal();
        return;
      }

      // safe guard for Canada zip.
      this.search = this.location.address_components[ 0 ].short_name.split( " " )[ 0 ];

      // Radius search logic for Hoodz
      if ( this.search && !!this.config.useRadius ) {
        // search for matching zipcode first.
        this.locations = this.filterSortDOTs();
        if ( !this.locations.length ) {
          // searching by radius
          this.locations = await this.searchByRadius();
        }

        if ( this.locations.length ) {
          this.mountOrigin();
          this.mountLocations( true );
          this.displayResults = true;
        } else {
          // display modal
          this.triggerNotFoundModal();
          return;

        }

      } else { // zip code search logic for Ductz

        this.locations = this.filterSortDOTsRSAs();

        if ( this.locations.length ) {
          this.mountOrigin();
          this.mountLocations( true );
          this.displayResults = true;
          return;
        } else {
          // display modal
          this.triggerNotFoundModal();
          return;
        }

      }
    },

    filterSortDOTs() {
      return this.allLocations.filter( loc => {
        loc.distance = +this.distance( loc, this.location );
        return loc.dots.find( d => d == this.search.toUpperCase() );
      } ).sort( ( a, b ) => {
        if ( a.distance > b.distance ) return 1;
        if ( a.distance < b.distance ) return -1;
        return 0;
      } ).splice( 0, +this.config.limit );
    },
    filterSortDOTsRSAs() {
      console.log( "filtering dots and rsas" );
      let locations = this.filterSortDOTs();

      if ( !locations.length ) {
        locations = this.allLocations.filter( loc => {
          loc.distance = +this.distance( loc, this.location );
          return loc.rsas.find( rsa => rsa == this.search.toUpperCase() );
        } ).sort( ( a, b ) => {
          if ( a.distance > b.distance ) return 1;
          if ( a.distance < b.distance ) return -1;
          return 0;
        } );

      }
      return locations.splice( 0, +this.config.limit );
    },
    triggerNotFoundModal() {
      this.showModal();
      this.loading = false;
      this.displayResults = false;
    },
    newSearchForZipOld() {
      if ( this.search ) {
        this.clearMarkers();

        this.loading = true;
        let url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + this.search + "&key=" +
                  this.config.googleMapAPI;
        $.getJSON( url )
         .done( result => {
           this.location = result.status === "OK" ? result.results[ 0 ] : null;
           this.markers = [];
           // console.log(this.location );
           this.locations = this.allLocations.filter( loc => {
                                  loc.distance = +this.distance( loc, this.location );
                                  console.log( loc.name, loc.distance );
                                  return loc.distance < this.config.radius;
                                } )
                                .sort( ( a, b ) => {
                                  if ( a.distance > b.distance ) return 1;
                                  if ( a.distance < b.distance ) return -1;
                                  return 0;
                                } )
                                .slice( 0, this.limit );

           this.loading = false;
           if ( this.locations.length ) {
             this.mountLocations( true );
             this.mountOrigin();
             this.displayResults = true;
           } else {
             // display modal
             this.showModal();
             this.loading = false;
             this.displayResults = false;
           }
         } );

      }
    },
    showModal() {
      this.reInitLocations();
      this.modal.show();
      $( "body" ).on( "click", "#closeBttn", () => this.hideModal() );
    },
    hideModal() {
      this.modal.hide();
    },
    searchForZip() {
      if ( this.search ) {
        this.clearMarkers();
        this.loading = true;
        $.post( this.url, { id: this.search }, results => {
          const locations = results.results;
          const origin = results.origin;
          // console.log( "locations:", locations );
          if ( locations === "not found" || !locations || !locations.length ) {
            this.showModal();
            this.loading = false;
            this.displayResults = false;
          } else {
            this.locations = [];
            for ( let i = 0; i < locations.length; i++ ) {
              const loc = locations[ i ];
              const zip = loc.zipcode;

              this.locations.push( {
                                     id:              loc.id,
                                     blog_id:         loc.blog.blog_id,
                                     name:            loc.name,
                                     lat:             zip.latitude,
                                     lng:             zip.longitude,
                                     address:         loc.address,
                                     address2:        loc.address2,
                                     city:            loc.city,
                                     state:           loc.state,
                                     zip:             loc.zip,
                                     emergency_phone: loc.emergency_phone,
                                     local_phone:     loc.local_phone,
                                     email:           loc.email,
                                     link:            this.cleanDomain( loc.blog.domain ),
                                     polygon:         zip.geometry,
                                     areas:           loc.support_zips,
                                     place:           loc.place,
                                     distance:        this.distance( loc, origin ),
                                     show_address:    loc.show_address,
                                   } );
            }

            this.sortByDistance();
            this.loading = false;
            this.mountLocations( true );
            this.mountOrigin( origin );
            this.displayResults = true;

          }
        } );
      }
    },
    mountOrigin() {
      const geo = this.location.geometry;
      const position = new google.maps.LatLng( geo.location.lat, geo.location.lng );
      this.location_marker = new google.maps.Marker( {
                                                       position: position,
                                                       map:      this.googleMap,
                                                       icon:     this.originMarkerIcon,
                                                       zIndex:   100,
                                                     } );
    },
    getCurrentPOS() {
      if ( navigator.geolocation ) {
        return new Promise( ( res, rej ) => {
          navigator.geolocation.getCurrentPosition( res, rej );
        } );
      } else {
        // Browser doesn't support Geolocation
        // handleLocationError(false, infoWindow, this.map.getCenter());
      }
    },
    addMarker( position, loc ) {
      // Add the marker at the clicked location, and add the next-available label
      // from the array of alphabetical characters.
      // console.log( "icon", this.markerIcon );
      // console.log('location: ', loc);
      const marker = new google.maps.Marker( {
                                               position: position,
                                               map:      this.googleMap,
                                               icon:     this.markerIcon,
                                               zIndex:   110,
                                             } );
      // marker.addListener( "click", () => {
      // 	this.infoWindowHandler( marker, loc );
      // 	this.mapPanHandler( marker );
      // 	this.googleMap.setZoom( 14 );
      // 	this.googleMap.setCenter( marker.getPosition() );
      // 	// console.log('marker position', marker.getPosition());
      // 	this.googleMap.panTo( marker.getPosition() );
      // } );
      marker.addListener( "mouseover", () => {
        if ( this.infoWindow ) this.infoWindow.close();
        this.infoWindowHoverHandler( marker, loc, true );
      } );
      marker.addListener( "click", () => {
        if ( this.infoWindow ) this.infoWindow.close();
        this.infoWindowHoverHandler( marker, loc, true );
      } );

// assuming you also want to hide the infowindow when user mouses-out
// 				marker.addListener( "mouseout", () => {
      // this.infoWindowHoverHandler( marker, loc, false );
      // } );
      this.markers.push( marker );

      return marker;

    },
    formatUrl( loc ) {
      let url = "https://maps.googleapis.com/maps/api/geocode/json?address=";
      if ( loc.address && loc.city && loc.state && loc.zip ) {
        let address = "";
        if ( loc.address2 ) {
          address =
              loc.address.trim() + ", " + loc.address2.trim() + ", " + loc.city.trim() + ", " +
              loc.state.trim() + ", " + loc.zip.trim();
        } else {
          address =
              loc.address.trim() + ", " + loc.city.trim() + ", " + loc.state.trim() + ", " + loc.zip.trim();
        }
        url = url + address + "&key=" + this.apiKey.trim();
        url = url.replace( "#", "" );
      }
      // console.log( url );
      return url;
    },
    getLocation( url ) {
      return $.getJSON( url )
              .done( location => ( location.results.length && location.status === "OK" ) &&
                                 this.googleLocations.push( location ) );
    },
    mountLocations( fitScreen = false ) {

      if ( this.locations ) {

        for ( let i = 0; i < this.locations.length; i++ ) {
          let loc = this.locations[ i ];

          if ( loc.place ) {
            const geo = loc.place.geometry;
            const position = new google.maps.LatLng( geo.location.lat, geo.location.lng );
            this.addMarker( geo.location, loc );
          }

          // if ( i === this.locations.length - 1 ) {
          //   this.clusterer = new MarkerClusterer( this.googleMap, this.markers,
          //                                         { imagePath: this.config.clusterers_folder + "/m" } );
          // }

          if ( i === this.locations.length - 1 && fitScreen ) {
            this.fitBoundsLocations();
          }

          // const url = this.formatUrl( loc );
          // console.log( "url: ", url );
          // if ( url ) {
          //
          // 	$.getJSON( url )
          // 	 .done( location => {
          // 		 if ( location.results.length && location.status === "OK" ) {
          // 			 let geo = location.results[ 0 ].geometry;
          // 			 // console.log( "geo", geo );
          // 			 const position = new google.maps.LatLng( geo.location.lat, geo.location.lng );
          // 			 this.addMarker( geo.location, loc );
          //
          // 		 }
          // 		 if ( i === this.locations.length - 1 && fitScreen ) {
          // 			 this.fitBoundsLocations();
          // 		 } else {
          //
          // 			 // customizing zoom here.
          // 			 // const zoom = this.googleMap.getZoom();
          // 			 // this.googleMap.setZoom( 5 );
          // 			 // 								 console.log( "zoom", zoom );
          // 			 // 								 console.log( "vss", this.$vssWidth );
          // 		 }
          // 	 } );
          //
          // }
        }
        this.loading = false;
        // this.map.fitBounds( bounds );
        // this.map.panToBounds(bounds);
        // if(finished){
        //   this.fitBoundsLocations();
        // }

      }

      // if ( this.locations ) {
      //
      //   for ( let i = 0; i < this.locations.length; i++ ) {
      //     let loc = this.locations[ i ];
      //
      //     if ( loc.place ) {
      //       const geo = loc.place.geometry;
      //       const position = new google.maps.LatLng( geo.location.lat, geo.location.lng );
      //       this.addMarker( geo.location, loc );
      //     }
      //
      //     if ( i === this.locations.length - 1 ) {
      //       this.clusterer = new MarkerClusterer( this.googleMap, this.markers,
      //                                             { imagePath: this.config.clusterers_folder + "/m" } );
      //     }
      //
      //     if ( i === this.locations.length - 1 && fitScreen ) {
      //       this.fitBoundsLocations();
      //     }
      //
      //     // const url = this.formatUrl( loc );
      //     // console.log( "url: ", url );
      //     // if ( url ) {
      //     //
      //     // 	$.getJSON( url )
      //     // 	 .done( location => {
      //     // 		 if ( location.results.length && location.status === "OK" ) {
      //     // 			 let geo = location.results[ 0 ].geometry;
      //     // 			 // console.log( "geo", geo );
      //     // 			 const position = new google.maps.LatLng( geo.location.lat, geo.location.lng );
      //     // 			 this.addMarker( geo.location, loc );
      //     //
      //     // 		 }
      //     // 		 if ( i === this.locations.length - 1 && fitScreen ) {
      //     // 			 this.fitBoundsLocations();
      //     // 		 } else {
      //     //
      //     // 			 // customizing zoom here.
      //     // 			 // const zoom = this.googleMap.getZoom();
      //     // 			 // this.googleMap.setZoom( 5 );
      //     // 			 // 								 console.log( "zoom", zoom );
      //     // 			 // 								 console.log( "vss", this.$vssWidth );
      //     // 		 }
      //     // 	 } );
      //     //
      //     // }
      //   }
      //   this.loading = false;
      // }

    },
    mapPanHandler( marker ) {
      // this.map.addListener( "center_changed", () => {
      //   this.map.panTo( marker.getPosition() );
      // } );
    },
    infoWindowHoverHandler( marker, location, open = true ) {
      if ( !open ) {
        this.infoWindow.close();
        return;
      }
      const btnId = "loc-" + location.id;
      const content = this.setInfoWindowConTent( location, btnId );
      this.infoWindow.setContent( content );
      this.infoWindow.open( this.googleMap, marker );

      const that = this;
      google.maps.event.addListener( this.infoWindow, "domready", () => {
        const $content = $( this.content );
        $( "a#" + btnId ).on( "click", function( evt ) {
          evt.preventDefault();
          // console.log( "location", location );
          // let url = "";
          // if ( process.env.node_env === "development" ) {
          //   url = `https://1800waterdamage.com.synapseresults.com/wp-json/public/v1/redirection/${ location.zip }`;
          // } else {
          let url = `${ that.config.domain }/wp-json/public/v1/update-location/${ location.id }`;
          // }
          that.loading = true;
          $.ajax( url )
           .done( res => {
             // console.log( "got the res", res );
             if ( res ) {
               window.location.replace( res );
             } else {
               window.location.replace( location.link );
             }
           } )
           .fail( r => {
             console.log( "error: ", r.response );
             window.location.replace( location.link );
           } );
        } );
      } );
    },
    setInfoWindowConTent( location, btnId ) {
      // const btnId = "loc-" + location.id;
      let content = "";
      if ( location.show_address ) {
        content = "<h2>" + location.name +
                  "</h2><p class='address'><a target='_blank' href='https://maps.google.com/?q=" +
                  location.address + location.city + ", " + location.state + " " + location.zip + "'>"
                  + location.address + "<br/>" + location.city + ", " + location.state + " " + location.zip +
                  "</a>" +
                  "<br/>" + "<a class='phone' href='tel:+1-" + location.local_phone + "'>" +
                  location.local_phone +
                  "</a>" + "</p>" +
                  "<a id='" + btnId + "' class='yellow-bttn infowindow-btn' href='" + location.link +
                  "'>View Website" + "</a>";
      } else {
        content = "<h2>" + location.name +
                  "</h2><p class='address'><br/>" + location.city + ", " + location.state + " " + location.zip + "<br/><a class='phone' href='tel:+1-" + location.local_phone + "'>" +
                  location.local_phone +
                  "</a>" + "</p>" +
                  "<a id='" + btnId + "' class='yellow-bttn infowindow-btn' href='" + location.link +
                  "'>View Website" + "</a>";
      }

      return content;
    },
    infoWindowHandler( marker, location ) {

      const btnId = "loc-" + location.id;
      const content = "<h2>" + location.name +
                      "</h2><p class='address'><a target='_blank' href='https://maps.google.com/?q=" +
                      location.address + location.city + ", " + location.state + " " + location.zip + "'>"
                      + location.address + "<br/>" + location.city + ", " + location.state + " " + location.zip +
                      "</a>" +
                      "<br/>" + "<a class='phone' href='tel:+1-" + location.local_phone + "'>" +
                      location.local_phone +
                      "</a>" + "</p>" +
                      "<a id='" + btnId + "' class='yellow-bttn infowindow-btn' href='" + location.link +
                      "'>View Website" + "</a>";
      // const $content = $( content );
      this.infoWindow.setContent( content );
      this.infoWindow.open( this.googleMap, marker );

      google.maps.event.addListener( this.infoWindow, "closeclick", () => {
        this.fitBoundsLocations();
      } );

      const that = this;
      google.maps.event.addListener( this.infoWindow, "domready", () => {
        const $content = $( this.content );
        $( "a#" + btnId ).on( "click", function( evt ) {
          evt.preventDefault();
          // console.log( "location", location );
          // let url = "";
          // if ( process.env.node_env === "development" ) {
          //   url = `https://1800waterdamage.com.synapseresults.com/wp-json/public/v1/redirection/${ location.zip }`;
          // } else {
          let url = `${ this.config.domain }/wp-json/public/v1/update-location/${ location.id }`;
          // }

          $.ajax( url )
           .done( res => {
             // console.log( "got the res", res );
             if ( res ) {
               window.location.replace( res );
             } else {
               window.location.replace( location.link );
             }
           } )
           .fail( r => {
             console.log( "error: ", r.response );
             window.location.replace( location.link );
           } );
        } );
      } );
    },
    btnOnclick( evt, location ) {

      evt.preventDefault();
      // console.log( "location", location );
      // let url = "";
      // if ( process.env.node_env === "development" ) {
      //   url = `https://1800waterdamage.com.synapseresults.com/wp-json/public/v1/redirection/${ location.zip }`;
      // } else {
      let url = `${ this.config.domain }/wp-json/public/v1/update-location/${ location.id }`;
      // }

      $.ajax( url )
       .done( res => {
         // console.log( "got the res", res );
         if ( res ) {
           window.location.replace( res );
         } else {
           window.location.replace( location.link );
         }
       } )
       .fail( r => {
         console.log( "errrrrr: ", r.response );
         window.location.replace( location.link );
       } );

    },
    getZipByLatLng( pos ) {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${ pos.lat },${ pos.lng }&key=${ this.config.googleMapAPI }`;
      return $.getJSON( url );
    },
    getZipcode( results ) {
      let add_comp = results[ 0 ].address_components.find( comp => {
        return comp.types.includes( "postal_code" );
      } );
      return add_comp.short_name;
    },
    autoLocate() {
      this.loading = true;
      this.getCurrentPOS().then( l => {
            return { lat: l.coords.latitude, lng: l.coords.longitude };
          } )
          .then( res => {
            this.getZipByLatLng( res )
                .done( res => {
                  // console.log( res );
                  this.search = this.getZipcode( res.results );
                  this.newSearchForZip();
                } );
          } )

          .catch( err => {
            // console.log( err );
            this.loading = false;
          } );
    },
    clearResults() {
      this.locations = [];
      this.clearMarkers();
      this.bounds = null;
      this.search = null;
      this.reInitLocations();
      const coords = new google.maps.LatLng( 39.8097343, -98.5556199 );
      this.googleMap.setCenter( coords );
      this.googleMap.setZoom( 5 );
    },
  },
  beforeMount() {

  },
  destroyed() {
    this.googleMap = null;
  },
};
</script>

<style lang="scss">

</style>
